import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth';

export default function RequireAuth({ children, role }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="max-w-7xl mx-auto px-6 py-20 text-center text-slate-500">Loading...</div>;
  if (!user) return <Navigate to={`/login?redirect=${encodeURIComponent(location.pathname)}`} replace />;
  if (role && role !== user.role && user.role !== 'admin') {
    return <Navigate to="/" replace />;
  }
  return children;
}
